const benifitsData = [
  {
    id: 1,
    icon: (
      <svg
        width="45"
        height="45"
        className="fill-current"
        viewBox="0 0 121.7 122.881"
      >
        <g>
          <path d="M80.833,29.638c0.309-0.061,0.63-0.002,0.896,0.161c0.455,0.188,0.776,0.635,0.778,1.158l0.264,36.584 c0.021,0.449-0.198,0.895-0.611,1.141l-14.941,8.912c-0.211,0.16-0.475,0.254-0.759,0.254c-0.069,0-0.138-0.004-0.204-0.016 l-38.773-4.311c-0.667-0.033-1.198-0.586-1.198-1.262V35.057h0.002c-0.015-0.498,0.268-0.979,0.752-1.191l19.45-8.55l0.001,0.002 c0.203-0.09,0.433-0.126,0.669-0.096L80.833,29.638L80.833,29.638L80.833,29.638z M53.613,0c14.789,0,28.202,6.018,37.918,15.694 c9.716,9.716,15.694,23.089,15.694,37.918c0,10.817-3.226,20.927-8.732,29.343l23.207,25.293l-16.009,14.633L83.311,98.258 c-8.497,5.664-18.724,8.967-29.697,8.967c-14.79,0-28.203-6.018-37.918-15.693C5.979,81.814,0,68.441,0,53.612 c0-14.79,6.019-28.202,15.695-37.918C25.41,5.979,38.784,0,53.613,0L53.613,0z M87.283,19.942 c-8.614-8.614-20.532-13.964-33.67-13.964s-25.056,5.35-33.67,13.964S5.979,40.475,5.979,53.612 c0,13.138,5.349,25.056,13.963,33.671c8.614,8.613,20.533,13.963,33.67,13.963s25.056-5.35,33.67-13.963 c8.614-8.615,13.964-20.533,13.964-33.671C101.247,40.475,95.897,28.557,87.283,19.942L87.283,19.942L87.283,19.942z M68.174,40.325v33.136l11.626-6.57l-0.244-33.406L68.174,40.325L68.174,40.325L68.174,40.325z M64.293,73.824V40.677l-15.63-1.657 l-0.542,15.802l-5.806-3.954l-5.806,3.281l1.198-16.528l-7.994-1.135V70.23L64.293,73.824L64.293,73.824L64.293,73.824z M62.583,29.782L50.84,36.253l15.863,2.024l10.666-6.556L62.583,29.782L62.583,29.782L62.583,29.782z M39.712,34.833l11.373-6.559 l-3.899-0.511l-14.592,6.161L39.712,34.833L39.712,34.833z" />
        </g>
      </svg>
    ),
    title: "Product Information",
    paragraph:
      "Empower consumers to make informed purchasing decisions by providing detailed product specifications, pricing information, and availability through interactive chatbot interfaces.",
  },
  {
    id: 2,
    icon: (
      <svg width="40" height="40" viewBox="0 0 40 40" className="fill-current">
        <path
          opacity="0.5"
          d="M20 30C22.75 30 25 32.25 25 35C25 37.75 22.75 40 20 40C17.25 40 15 37.75 15 35C15 32.25 17.25 30 20 30ZM35 30C37.75 30 40 32.25 40 35C40 37.75 37.75 40 35 40C32.25 40 30 37.75 30 35C30 32.25 32.25 30 35 30ZM35 15C37.75 15 40 17.25 40 20C40 22.75 37.75 25 35 25C32.25 25 30 22.75 30 20C30 17.25 32.25 15 35 15Z"
        />
        <path d="M20 15C22.75 15 25 17.25 25 20C25 22.75 22.75 25 20 25C17.25 25 15 22.75 15 20C15 17.25 17.25 15 20 15ZM20 0C22.75 0 25 2.25 25 5C25 7.75 22.75 10 20 10C17.25 10 15 7.75 15 5C15 2.25 17.25 0 20 0ZM5 30C7.75 30 10 32.25 10 35C10 37.75 7.75 40 5 40C2.25 40 0 37.75 0 35C0 32.25 2.25 30 5 30ZM5 15C7.75 15 10 17.25 10 20C10 22.75 7.75 25 5 25C2.25 25 0 22.75 0 20C0 17.25 2.25 15 5 15ZM5 0C7.75 0 10 2.25 10 5C10 7.75 7.75 10 5 10C2.25 10 0 7.75 0 5C0 2.25 2.25 0 5 0ZM35 0C37.75 0 40 2.25 40 5C40 7.75 37.75 10 35 10C32.25 10 30 7.75 30 5C30 2.25 32.25 0 35 0Z" />
      </svg>
    ),
    title: "Document/Report Accessibility",
    paragraph:
      "Improve reader engagement and convenience by incorporating QR codes generated by XplorEase on report covers and other critical documents, granting easy access to additional information, summaries, and interactive features.",
  },
  {
    id: 3,
    icon: (
      <svg width="45" height="45" className="fill-current" viewBox="0 0 32 32">
        <g id="SVGRepo_iconCarrier">
          <g transform="matrix(1,0,0,1,-48,-336)">
            <g transform="matrix(0.8,0,0,1,11,1)">
              <path
                opacity="0.5"
                d="M55,350C55,349.448 54.44,349 53.75,349C52.986,349 52.014,349 51.25,349C50.56,349 50,349.448 50,350C50,351.537 50,354.463 50,356C50,356.552 50.56,357 51.25,357C52.014,357 52.986,357 53.75,357C54.44,357 55,356.552 55,356C55,354.463 55,351.537 55,350Z"
              ></path>
            </g>
            <g transform="matrix(0.8,0,0,1,33,1)">
              <path
                opacity="0.5"
                d="M55,350C55,349.448 54.44,349 53.75,349C52.986,349 52.014,349 51.25,349C50.56,349 50,349.448 50,350C50,351.537 50,354.463 50,356C50,356.552 50.56,357 51.25,357C52.014,357 52.986,357 53.75,357C54.44,357 55,356.552 55,356C55,354.463 55,351.537 55,350Z"
              ></path>
            </g>
            <g transform="matrix(1.2,0,0,1.2,-13.4,-70.8)">
              <path
                opacity="0.5"
                d="M67,360.667C67,359.746 66.254,359 65.333,359L63.667,359C62.746,359 62,359.746 62,360.667L62,362.333C62,363.254 62.746,364 63.667,364L65.333,364C66.254,364 67,363.254 67,362.333L67,360.667Z"
              ></path>
            </g>
            <path
              fill="fill-current"
              d="M52.041,349L52,349C50.895,349 50,349.895 50,351L50,357C50,358.105 50.895,359 52,359L54,359C55.105,359 56,358.105 56,357L56,351C56,349.912 55.131,349.027 54.049,349.001C54.551,343.95 58.818,340 64,340C69.182,340 73.449,343.95 73.951,349.001C72.869,349.027 72,349.912 72,351L72,357C72,358.093 72.876,358.981 73.965,359C73.937,359.195 73.893,359.385 73.834,359.568C73.382,360.978 72.059,362 70.5,362L68,362C68,360.343 66.657,359 65,359L63,359C61.343,359 60,360.343 60,362C60,362.329 60,362.671 60,363C60,364.657 61.343,366 63,366L65,366C66.311,366 67.426,365.159 67.834,363.986C67.888,363.995 67.943,364 68,364L70.5,364C72.95,364 75.028,362.394 75.738,360.179C75.859,359.802 75.941,359.407 75.977,359L76,359C77.105,359 78,358.105 78,357L78,351C78,349.895 77.105,349 76,349L75.959,349C75.455,342.895 70.371,338.08 64.155,338.001L64,338C57.713,338 52.55,342.845 52.041,349ZM66,362L66,363C66,363.552 65.552,364 65,364C65,364 63,364 63,364C62.448,364 62,363.552 62,363L62,362C62,361.448 62.448,361 63,361C63,361 65,361 65,361C65.552,361 66,361.448 66,362ZM54,351L52,351L52,357L54,357L54,351ZM76,351L74,351L74,357L76,357L76,351Z"
            ></path>
          </g>
        </g>
      </svg>
    ),
    title: "Customer Service",
    paragraph:
      "Streamline customer support processes by deploying AI-powered chatbots to address frequently asked questions, resolve issues, and provide timely assistance, ultimately improving customer satisfaction and loyalty.",
  },
  {
    id: 4,
    icon: (
      <svg width="40" height="40" viewBox="0 0 16 16" className="fill-current">
        <g id="SVGRepo_iconCarrier">
          <path d="M14.25 2.1a1.25 1.25 0 0 0-1.17-.1L6.91 4.43a1.22 1.22 0 0 1-.46.09H2.5a1.25 1.25 0 0 0-1.25 1.25v.1H0v3h1.25V9a1.25 1.25 0 0 0 1.25 1.22L4 13.4a1.26 1.26 0 0 0 1.13.72h.63A1.25 1.25 0 0 0 7 12.87v-2.53l6.08 2.43a1.27 1.27 0 0 0 .47.09 1.29 1.29 0 0 0 .7-.22 1.25 1.25 0 0 0 .55-1V3.13a1.25 1.25 0 0 0-.55-1.03zm-8.5 3.67V9H2.5V5.77zm0 7.1h-.63l-1.23-2.65h1.86zm1.62-3.72A2.29 2.29 0 0 0 7 9V5.7a2.26 2.26 0 0 0 .37-.11l6.18-2.46v8.48zm7.46-3.03v2.5a1.25 1.25 0 0 0 0-2.5z"></path>
        </g>
      </svg>
    ),
    title: "Marketing",
    paragraph:
      "Drive engagement and conversions by delivering tailored product information, promotional offers, and brand messaging through interactive chatbot experiences, effectively guiding consumers through the purchasing journey.",
  },
  {
    id: 5,
    icon: (
      <svg width="40" height="40" viewBox="0 0 24 24" className="fill-current">
        <g>
          <path d="M20,7.4v10.5c0,1.7-1.3,3-3,3H5.9c0,1.1,0.9,2,2,2H18c2.2,0,4-1.8,4-4V9.4C22,8.3,21.1,7.4,20,7.4z" />
          <g>
            <path
              d="M5,1.1v2H4c-1.1,0-2,0.9-2,2v12c0,1.1,0.9,2,2,2h12.2c1.1,0,2-0.9,2-2v-12c0-1.1-0.9-2-2-2h-1v-2h-2v2H7v-2
			C7,1.1,5,1.1,5,1.1z M4,8.1h12.2v9H4V8.1z"
            />
            <path d="M13.7,16.3l-2.4-1.4L9,16.3l0.6-2.7l-2.1-1.8l2.8-0.2L11.4,9l1.1,2.5l2.8,0.3l-2.1,1.8L13.7,16.3z" />
          </g>
        </g>
        <rect className="fill-none" width="24" height="24" />
      </svg>
    ),
    title: "Event Management",
    paragraph:
      "Facilitate seamless event planning and execution by providing attendees with real-time updates on schedules, speakers, and ticketing information, enhancing attendee satisfaction and overall event experience.",
  },
  {
    id: 6,
    icon: (
      <svg width="40" height="45" viewBox="0 0 24 24" className="fill-current">
        <path d="M22,1H18a1,1,0,0,0-1,1V9H15V7a1,1,0,0,0-1.447-.895L9,8.382V7a1,1,0,0,0-1.447-.895l-6,3A1,1,0,0,0,1,10V22a1,1,0,0,0,1,1H22a1,1,0,0,0,1-1V2A1,1,0,0,0,22,1ZM21,3V5H19V3ZM3,21V10.618l4-2V10a1,1,0,0,0,1.447.895L13,8.618V10a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V7h2V21Zm2-8H8v2H5Zm5,0h4v2H10Zm6,0h3v2H16ZM5,17H8v2H5Zm5,0h4v2H10Zm6,0h3v2H16Z" />
      </svg>
    ),
    title: "Retail/Manufacturing",
    paragraph:
      "Optimize operational efficiency and employee productivity by equipping them with access to essential production data, safety protocols, and company policies through AI-driven chatbot interfaces, promoting adherence to best practices and regulatory standards.",
  },
];
export default benifitsData;
